import { Alert, Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

import RenderIf from '../../../renderIf';

const UserAlert = (props) => {
    const { type, text, actions } = props;

    return (
        <Alert
            severity={!!type ? type : 'info'}
            sx={{
                margin: '1rem 3rem',
                borderRadius: '16px',
            }}
            icon={
                <FontAwesomeIcon
                    icon={faExclamationCircle}
                    transform="shrink-3"
                />
            }
        >
            <Typography>{text}</Typography>
            <RenderIf isTrue={React.isValidElement(actions)}>
                <Box
                    sx={{
                        margin: 'auto',
                        textAlign: 'center',
                    }}
                >
                    {actions}
                </Box>
            </RenderIf>
        </Alert>
    );
};

export default UserAlert;
